import { APP_ROUTE_PATHS } from '@ps/core-config';
import { UNDER_CONSTRUCTION_TITLE } from './utils/under-construction.helper';
import { Route } from '@angular/router';
import { roleGuard } from '@ps/user-settings-data-access';
import { UserType } from '@ps/core-models';
import { UnderConstructionPage } from '../pages/status-pages/under-construction/under-construction.page';

function supplierLegacyUnderConstruction(
  path: string,
  legacyUrl: string,
): Route {
  return {
    path,
    component: UnderConstructionPage,
    canActivate: [roleGuard],
    data: { roles: ['supplier'] as UserType[], legacyUrl },
    title: UNDER_CONSTRUCTION_TITLE,
  };
}
/**
 * Matches `APP_ROUTES.SUPPLIER_ROUTES`.
 * Wrapped in `AUTHENTICATED_APP_ROUTES` under a `roleGuard` group with `roles: ['supplier']`.
 */
export const SUPPLIER_ROUTES: Route[] = [
  supplierLegacyUnderConstruction(
    APP_ROUTE_PATHS.manageBuyers,
    '/supplier/manage-buyers',
  ),
  supplierLegacyUnderConstruction(
    APP_ROUTE_PATHS.supplierSettings,
    '/supplier/supplier-settings',
  ),
  supplierLegacyUnderConstruction(
    APP_ROUTE_PATHS.supplierPricingCard,
    '/supplier/supplier-pricing-card',
  ),
];
